document.addEventListener('DOMContentLoaded', function() {
    // Function to attach zoom functionality to product cards
    function attachZoomToCards() {
        const cardMediaElements = document.querySelectorAll('[data-product-card-zoom]');
        
        cardMediaElements.forEach(function(cardMedia) {
            // Skip if already initialized
            if (cardMedia.dataset.zoomInitialized) return;
            
            const zoomPopup = cardMedia.querySelector('[data-product-card-zoom-popup]');
            
            if (!zoomPopup) return;
            
            // Mark as initialized
            cardMedia.dataset.zoomInitialized = 'true';
            
            // Show popup on mouse enter
            cardMedia.addEventListener('mouseenter', function() {
                zoomPopup.classList.add('active');
            });
            
            // Position popup on mouse move
            cardMedia.addEventListener('mousemove', function(e) {
                const popupX = e.clientX + 15;
                const popupY = e.clientY + 15;
                
                zoomPopup.style.left = popupX + 'px';
                zoomPopup.style.top = popupY + 'px';
            });
            
            // Hide popup on mouse leave
            cardMedia.addEventListener('mouseleave', function() {
                zoomPopup.classList.remove('active');
            });
        });
    }
    
    // Initial attachment
    attachZoomToCards();
    
    // Watch for dynamic product loading - observe for new cards added to product blocks
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                // Check if any new product cards were added
                let hasNewCards = false;
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        if (node.classList && (node.classList.contains('product') || node.querySelector && node.querySelector('[data-product-card-zoom]'))) {
                            hasNewCards = true;
                        }
                    }
                });
                if (hasNewCards) {
                    // Give the DOM a moment to fully render
                    setTimeout(attachZoomToCards, 100);
                }
            }
        });
    });
    
    // Observe product blocks and product grids for new products
    const productBlocks = document.querySelectorAll('[data-product-block], .halo-block-content, .products-grid, .products-carousel, .products-flex');
    productBlocks.forEach(function(block) {
        observer.observe(block, {
            childList: true,
            subtree: true
        });
    });
});


